export default function (price, noValue = ' ') {
  if (
    price &&
    price.amount !== undefined &&
    price.amount !== null &&
    !isNaN(price.amount) &&
    (price.amount || price.allowZero)
  ) {
    var prefix = price.currency
    switch (price.currency) {
    case 'USD':
      prefix = 'US$'
      break
    case 'AUD':
      prefix = 'A$'
      break
    case 'CAD':
      prefix = 'CA$'
      break
    case 'NZD':
      prefix = 'NZ$'
      break
    case 'ZAR':
      prefix = 'R'
      break
    case 'EUR':
      prefix = '€'
      break
    case 'GBP':
      prefix = '£'
      break
    }
    return (
      (price.noPrefixSymbol ? '' : (price.amount <= 0 ? '+ ' : '- ')) +
      prefix +
      ((price.amount - Math.floor(price.amount)) !== 0 ?
        Math.abs(price.amount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') :
        Math.abs(price.amount).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'))
    )
  } else {
    return noValue
  }
}
